export enum ViewMode {
    VIEW,
    EDIT,
    INSERT,
}